import React from 'react'
import { Route, Redirect, Link, Switch } from 'react-router-dom'
import { Result, Button } from 'antd'
import Loadable from 'react-loadable'
import Loading from './components/Loading'
import store from './store'
import PageLayout from './pages/layout'

const UploadPage = Loadable({
    loader: () => import('./pages/upload'),
    loading: Loading,
})
const ApprovePage = Loadable({
    loader: () => import('./pages/approve'),
    loading: Loading,
})

const SearchPage = Loadable({
    loader: () => import('./pages/search'),
    loading: Loading,
})
const GraphPage = Loadable({
    loader: () => import('./pages/graph'),
    loading: Loading,
})

const ContractPage = Loadable({
    loader: () => import('./pages/contract'),
    loading: Loading,
})

class Home extends React.Component<any, any> {
    public render() {
        const { history } = this.props
        const { authStore } = store
        return (
            <PageLayout history={history}>
                <Switch>
                    <Route
                        exact={true}
                        path='/'
                        render={(props) => {
                            return store.authStore.islogin
                                ? <Redirect to={authStore.selectDefaultPath()} {...props} /> : <Redirect to='/login' />
                        }}
                    />
                    <Route
                        exact={true}
                        path='/upload'
                        render={(props) => {
                            return store.authStore.allowAccess('submitter')
                                ? <UploadPage {...props} /> :
                                (store.authStore.islogin ? <Redirect to='/403' /> : <Redirect to='/login' />)
                        }}
                    />
                    <Route
                        exact={true}
                        path='/approve'
                        render={(props) => {
                            return store.authStore.allowAccess('approver')
                                ? <ApprovePage {...props} /> :
                                (store.authStore.islogin ? <Redirect to='/403' /> : <Redirect to='/login' />)
                        }}
                    />
                    <Route
                        exact={true}
                        path='/search'
                        render={(props) => {
                            return store.authStore.allowAccess(['viewer', 'privileged viewer'])
                                ? <SearchPage {...props} /> :
                                (store.authStore.islogin ? <Redirect to='/403' /> : <Redirect to='/login' />)
                        }}
                    />

                    <Route
                        exact={true}
                        path='/graph'
                        render={(props) => {
                            return store.authStore.allowAccess(['viewer', 'privileged viewer'])
                                ? <GraphPage {...props} /> :
                                (store.authStore.islogin ? <Redirect to='/403' /> : <Redirect to='/login' />)
                        }}
                    />

                    <Route
                        path='/contract'
                        render={(props) => {
                            return store.authStore.islogin
                                ? <ContractPage {...props} /> : <Redirect to='/login' />
                        }}
                    />
                    <Route
                        path='/403'
                        exact={true}
                        render={() => {
                            return (
                                store.authStore.islogin ?
                                    (
                                        <Result
                                            status='403'
                                            title='403'
                                            subTitle='You are not privileged to the page. Please contact the system administrator.'
                                            extra={<Button type='primary'><Link to='/'>Back Home</Link></Button>}
                                        />
                                    )
                                    :
                                    <Redirect to='/login' />
                            )
                        }}
                    />

                    <Route
                        path='*'
                        render={() => {
                            return (
                                store.authStore.islogin ?
                                    (
                                        <Result
                                            status='404'
                                            title='404'
                                            subTitle='Sorry, the page you visited does not exist.'
                                            extra={<Button type='primary'><Link to='/'>Back Home</Link></Button>}
                                        />
                                    )
                                    :
                                    <Redirect to='/login' />
                            )
                        }}
                    />
                </Switch>
            </PageLayout>
        )
    }
}

export default Home
